export const createStoreModulePath = (prefix: string) => (accessor: string) => `${prefix}/${accessor}`;